// @flow
import fp from "lodash/fp"

import type {
  PriorityBoardingData,
  PriorityBoardingFlightLogFormat,
  PriorityBoardingFlightOrdered,
  PriorityBoardingLogFormat,
  PriorityBoardingOrdered,
  PriorityBoardingSaveFormat,
} from "booking/services/additionalServices/services/priorityBoarding/services/types"

export const formatOneFlight = (numOfPassengers: number = 1) => (
  priorityBoardingFlightOrdered: PriorityBoardingFlightOrdered,
): boolean[] =>
  fp.reduce(
    (acc, key) => {
      // relies on the number of passengers set in params
      if (acc[key] !== undefined) {
        acc[key] = priorityBoardingFlightOrdered[key]
      }
      return acc
    },
    fp.fill(0, numOfPassengers, false, new Array(numOfPassengers)),
    fp.keys(priorityBoardingFlightOrdered),
  )

export const formatToSaveBooking: number => PriorityBoardingOrdered => PriorityBoardingSaveFormat = (
  numOfPassengers: number = 1,
) => fp.mapValues(formatOneFlight(numOfPassengers))

export const formatOneFlightToLog = (
  numOfPassengers: number = 1,
  priorityBoardingFlightOrdered: PriorityBoardingFlightOrdered,
  prefix?: string = "passenger_",
): PriorityBoardingFlightLogFormat => {
  const formatted = formatOneFlight(numOfPassengers)(priorityBoardingFlightOrdered)
  return fp.reduce(
    (acc, index) => fp.set(`${prefix}${index}`, formatted[index], acc),
    {},
    fp.range(0, numOfPassengers),
  )
}

export const formatToLog = (
  numOfPassengers: number = 1,
  priorityBoardingData: PriorityBoardingData,
  priorityBoardingOrdered: PriorityBoardingOrdered,
  prefix?: string = "passenger_",
): PriorityBoardingLogFormat =>
  // $FlowFixMe: error revealed by updating Flow and lodash libdef, please fix
  fp.reduce(
    (acc, flightId) =>
      fp.set(
        flightId,
        formatOneFlightToLog(numOfPassengers, priorityBoardingOrdered[flightId], prefix),
        acc,
      ),
    {},
    fp.keys(priorityBoardingData),
  )
